<div class="row preferred-dist">
    <div class="col-sm-12">
        <mat-label
        ><h5><b>{{ 'Search results' | translate }}</b></h5></mat-label
        >
        <mat-radio-group
        class="id-radio-group"
        [formControl]="householdIdControl"
        required
        >
        <div *ngFor="let surveyGroup of groupedSurveys | keyvalue" class="option-container">
            <mat-radio-button
                class="id-radio-button"
                [value]="surveyGroup.key"
                >
                    <mat-accordion>
                        <mat-expansion-panel class="expansion-panel" [hideToggle]="false" [expanded]="true">
                        <mat-expansion-panel-header class="student-title">
                            <mat-panel-title>
                            {{ 'Students Information' | translate }}
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="student-card" *ngFor="let student of surveyGroup.value; let i = index">
                            <p class="info-label"><b>{{'Student Information' | translate }} #{{ i + 1 }}</b></p>
                            <p class="info-label"><b>{{ 'District' | translate }}:</b> {{ getDistrictName(student.institutionId) }}</p>
                            <p class="info-label"><b>{{ 'School' | translate }}:</b> {{ getSchoolName(student.facilityId) }}</p>
                            <p class="info-label"><b>{{ 'Grade' | translate }}:</b> {{ getGradeName(student.unitId) }}</p>
                        </div>
                        </mat-expansion-panel>
                    </mat-accordion>
            </mat-radio-button>
        </div>
        </mat-radio-group>
    </div>
</div>

<div class="save-btn">
    <button mat-flat-button color="primary" (click)="onCancel()">
      {{ "Cancel" | translate }}
    </button>
    <button mat-flat-button color="primary" (click)="onConfirm()">
      {{ "Continue" | translate }}
    </button>
  </div>
